import WebSection from "./Sections/WebSection";
import MobileSection from "./Sections/MobileSection";
import { getLoanDetailFormattedSectionData } from "./Utilites/FormattedSectionData";

import { LoanDetailFields } from "../../services/LoanApplication/constants";
import { UserPermission } from "../../dtos/DashboardUserDTO";

interface DetailsTabData {
  loanDetails: any;
  token: string;
  pageConfig: any;
  defaultConfig: any;
  loanID: string;
  sourceEntityID?: string;
  pageName: string;
  canUser: any;
  permissions: UserPermission;
  loanDetailFields?: LoanDetailFields;
  isLenderDashboard: boolean;
  whiteLabelStyle: {};
  resourceName: string;
  service: string;
  notify: any;
  resourceNameSingleSubmit: string;
  lapStudio?: boolean;
  useLocation?: any;
  useNavigate?: any;
  isMFL_LAP: boolean;
}

const LoanDetailsTab = (detailsTabData: DetailsTabData) => {
  const {
    resourceName,
    service,
    pageName,
    loanDetailFields,
    loanDetails,
    pageConfig,
    token,
    isLenderDashboard,
    whiteLabelStyle,
    defaultConfig,
    sourceEntityID,
    loanID,
    notify,
    resourceNameSingleSubmit,
    lapStudio,
    useLocation,
    useNavigate,
    isMFL_LAP
  } = detailsTabData;

  const data = getLoanDetailFormattedSectionData(
    loanDetails,
    pageConfig?.[pageName],
    sourceEntityID,
    loanDetails.userID,
    defaultConfig?.[pageName],
    loanDetailFields
  );

  return (
    <>
      {/* Detail Section Three Section 
                1. Loan Details 
                2. Additional Info
                3. Communication Details
            */}
      <WebSection
        data={data}
        loanID={loanID}
        whiteLabelStyle={whiteLabelStyle}
        pageConfig={pageConfig}
        pageName={pageName}
        token={token}
        isLenderDashboard={isLenderDashboard}
        resourceName={resourceName}
        service={service}
        userID={loanDetails?.userID ?? ""}
        notify={notify}
        resourceNameSingleSubmit={resourceNameSingleSubmit}
        lapStudio={lapStudio}
        useLocation={useLocation}
        useNavigate={useNavigate}
        isMFL_LAP={isMFL_LAP}
      />

      {/* Mobile Section includes three section 
               1. Mobile Detail Section 
               2. Activity Timeline
               3. KYC Docs
            */}
      <MobileSection
        pageConfig={pageConfig}
        loanDetails={loanDetails}
        isLenderDashboard={isLenderDashboard}
        loanID={loanID}
        pageName={pageName}
        token={token}
        whiteLabelStyle={whiteLabelStyle}
      />
    </>
  );
};

export default LoanDetailsTab;
